import { experienceLabel } from '@dashboard/services/string'
import type { Config } from '@dashboard/types/config'
import { segmentName } from '@shared/services/segmentName'

export const MAX_FILL_TARGETS = 10
export const DEFAULT_FILL_CONFIDENCE = 0.8
export const FILL_CONFIDENCE_PRESETS = [
  { label: 'Very sure', value: 0.9 },
  { label: 'Fairly sure', value: DEFAULT_FILL_CONFIDENCE },
  { label: 'Somewhat sure', value: 0.65 }
]

export function fillConfidenceLabel(value: number): string {
  return FILL_CONFIDENCE_PRESETS.find((preset) => preset.value === value)?.label ?? `${Math.round(value * 100)}% sure`
}

export interface FillTarget {
  dimensionId: string
  label: string
  answers: { segmentId: string; label: string }[]
}

/**
 * Segment groups a text answer can fill, worded as the server words them for Jev: the question that asks
 * the group (else its name), and that question's answer labels (else segment names via `segmentName()`, so
 * the built-in Other answer reads as the question's Other label).
 */
export function fillTargets(config: Config | null | undefined): FillTarget[] {
  const questions = config?.rightAsk?.questions ?? []
  const nameOptions = {
    segmentGroups: config?.dimensions ?? [],
    questions: questions.map((question) => ({
      segmentGroupId: question.dimensionId,
      otherOptions: question.otherOptions
    }))
  }
  return (config?.dimensions ?? []).flatMap((dimension) => {
    const question = questions.find((item) => item.dimensionId === dimension.id)
    const answers = dimension.segments
      .filter((segment) => segment.id !== '$everyone')
      .map((segment) => ({
        segmentId: segment.id,
        label:
          (segment.name !== 'INT_OTHER' &&
            experienceLabel(question?.options.find((option) => option.segmentId === segment.id)?.label)) ||
          experienceLabel(segmentName(segment, nameOptions))
      }))
    if (!answers.length) {
      return []
    }
    return [
      { dimensionId: dimension.id, label: experienceLabel(question?.text) || experienceLabel(dimension.name), answers }
    ]
  })
}
